import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowDropDownSvg } from "./IconArrowDropDownSvg.mjs";
const IconArrowDropDown = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowDropDownSvg, ...iconProps });
};
export {
  IconArrowDropDown
};
